// extracted by mini-css-extract-plugin
module.exports = {"trainerError":"TrainerSelector_trainerError__8UZ7Y","bottomSpace":"TrainerSelector_bottomSpace__1hbbe"};